module.exports = __webpack_public_path__ + "assets/img/1d05ce28e0ae9c648254a7d62ee7e3d0.png";